import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationPanelComponent } from './navigation-panel/navigation-panel.component';
import { NavigationListContainerComponent } from './navigation-list/navigation-list-container/navigation-list-container.component';
import { NavigationListItemComponent } from './navigation-list/navigation-list-item/navigation-list-item.component';
import { IconModule } from '../icon/icon.module';
import { NavigationListDividerComponent } from './navigation-list/navigation-list-divider/navigation-list-divider.component';

@NgModule({
  declarations: [
    NavigationPanelComponent,
    NavigationListContainerComponent,
    NavigationListItemComponent,
    NavigationListDividerComponent,
  ],
  imports: [CommonModule, IconModule],
  exports: [
    NavigationPanelComponent,
    NavigationListContainerComponent,
    NavigationListItemComponent,
    NavigationListDividerComponent,
  ],
})
export class NavigationModule {}
